const HeroSection: React.FC = () => {
  return (
    <div className="w-full mx-auto max-w-[1699px] h-[300px] sm:h-[400px] md:h-[500px] lg:h-[550px] xl:h-[628px]">
      <div className="w-full h-full">
        <img
          src="./web-ttmi/about/web-TT-3.jpg"
          alt="Hero"
          className="w-full h-full object-cover object-left sm:object-center"
        />
      </div>
    </div>
  )
}

export default HeroSection
